module.exports = __webpack_public_path__ + "img/2keinstellungen_invalid.0aa0c713.png";